module.exports = __webpack_public_path__ + "img/ventilation.78ac091e.jpeg";